export const PORTAL_COOKIE_CONFIG: CookieConfig = {
  name: 'portal_user',
  path: '/',
  maxAge: 24 * 60 * 60, // 24 hours
  httpOnly: true,
  secure: process.env.NODE_ENV === 'production',
  sameSite: 'lax',
};

// Cookie domain is environment-driven so it can be verified locally / on previews.
const TRACKING_COOKIE_DOMAIN =
  process.env.VERCEL_ENV === 'production' ? '.zoefin.com' : undefined;

// Shared attributes for every tracking cookie.
// httpOnly:false -> client code (MetaConversions, createHubspotMeta) must read them.
export const TRACKING_COOKIE_OPTIONS = {
  domain: TRACKING_COOKIE_DOMAIN,
  path: '/',
  sameSite: 'lax',
  secure: process.env.NODE_ENV === 'production',
  httpOnly: false,
} as const;

// Environment variables
export const COOKIE_DURATION = parseInt(
  process.env.PORTAL_COOKIE_SESSION_DURATION || '86400',
  10,
); // 24 hours

// Encryption constants
export const ENCRYPTION_KEY = process.env.PORTAL_COOKIE_SECRET; // In production, this should be from environment variables
export const SALT = process.env.PORTAL_COOKIE_SALT; // In production, this should be from environment variables
export const IV_LENGTH = 12; // 96 bits for GCM
export const KEY_LENGTH = 256;

// Cookie names (FPC = First-Party Cookies)
export const UTM_PARAMS_FPC_NAME = '_utm_params';
export const HUBSPOTUTK_FPC_NAME = '_hubspotutk';
export const FBCLID_FPC_NAME = '_fbclid';

// UTM keys we persist; anything not in this list is ignored
export const TRACKED_UTM_PARAMS = [
  'utm_medium',
  'utm_source',
  'utm_content',
  'utm_term',
  'utm_campaign',
] as const;

export const FBCLID_UTM_COOKIE_MAX_AGE = 90 * 24 * 60 * 60; // 90 days
export const HUBSPOTUTK_COOKIE_MAX_AGE = 396 * 24 * 60 * 60; // 396 days (~13 months)
